import React from "react";

export const TickGreen = () => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.271779 8.68874C-0.0970589 8.3068 -0.0864351 7.69817 0.295507 7.32933L2.37021 5.32581C2.75215 4.95698 3.36078 4.9676 3.72962 5.34954L11.0758 12.9568L7.61801 16.296L0.271779 8.68874Z"
        fill="#ABD673"
      />
      <path
        d="M16.2712 0.631445C16.64 0.249502 17.2487 0.238879 17.6306 0.607716L19.7053 2.61123C20.0873 2.98007 20.0979 3.5887 19.729 3.97064L11.0471 12.961L7.5893 9.62183L16.2712 0.631445Z"
        fill="#ABD673"
      />
    </svg>
  );
};
